import React from 'react';
import {
    Button, Row, Col, Spinner,
} from 'reactstrap';
import { getShort } from '@s20/common/util/date';
import { httpClient } from '@s20/services/httpClient';
import { Can } from '../Can';
import { SmallButton } from '../common/forms/FormElements';
import CommonContext, { ApiRoutes } from '../Common';
import { LongTermStatusType } from '../longTermStatus/LongTermStatus';

export class EmployeeLongTermStatusInfo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            longTermStatuses: [],
        };
    }

    componentDidMount() {
        this.populateState();
    }

    getLongTermStatusName = (employeeLongTermStatus) => {
        if (!employeeLongTermStatus) {
            return '';
        }

        const { longTermStatuses } = this.state;

        const longTermStatus = longTermStatuses.find(
            (l) => l.id == employeeLongTermStatus.longTermStatusId,
        );

        return longTermStatus.name;
    };

    async populateState() {
        const [longTermStatuses] = await Promise.all([
            httpClient.js(ApiRoutes.longTermStatus.byTypeId(LongTermStatusType.Employee)),
        ]);

        this.setState({ longTermStatuses, loading: false });
    }

    render() {
        const { employeeLongTermStatuses } = this.props;

        if (this.state.loading) {
            return (
                <Spinner />
            );
        }

        return (
            <>
                <Row className="pb-1">
                    <Col>
                        <div className="d-flex flex-row align-items-center justify-content-end">
                            <Can
                                I="edit"
                                a="employee"
                            >
                                <CommonContext.Consumer>
                                    {(value) => (
                                        <SmallButton
                                            disabled={!!value.formIsOpen}
                                            type="button"
                                            onClick={
                                                this.props
                                                    .onAddEmployeeLongTermStatus
                                            }
                                        >
                                            <i className="fa fa-plus-circle fa-md mr-2" />
                                            Add Long-Term Status
                                        </SmallButton>
                                    )}
                                </CommonContext.Consumer>
                            </Can>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <table className="table table-sm table-bordered">
                            <thead className="text-muted">
                                <tr>
                                    <th>Name</th>
                                    <th>Effective Date</th>
                                    <th>Expiration Date</th>
                                    <Can
                                        I="edit"
                                        a="employeelongtermstatus"
                                    >
                                        <th
                                            className="text-center"
                                            style={{ width: '30px' }}
                                        />
                                    </Can>
                                </tr>
                            </thead>
                            <tbody>
                                {!(employeeLongTermStatuses ?? []).length ? (
                                    <tr>
                                        <td
                                            colSpan="4"
                                            className="text-center"
                                        >
                                            No long term statuses found.
                                        </td>
                                    </tr>
                                ) : (
                                    employeeLongTermStatuses.map(
                                        (selectedEmployeeLongTermStatus) => {
                                            const longTermStatusName = this.getLongTermStatusName(
                                                selectedEmployeeLongTermStatus,
                                            );

                                            return (
                                                <tr
                                                    key={
                                                        selectedEmployeeLongTermStatus.id
                                                    }
                                                >
                                                    <td>
                                                        {longTermStatusName}
                                                    </td>
                                                    <td>
                                                        {getShort(
                                                            selectedEmployeeLongTermStatus.startDate,
                                                        )}
                                                    </td>
                                                    <td>
                                                        {getShort(
                                                            selectedEmployeeLongTermStatus.endDate,
                                                        ) ?? 'Current'}
                                                    </td>
                                                    <Can
                                                        I="edit"
                                                        a="employeelongtermstatus"
                                                    >
                                                        <CommonContext.Consumer>
                                                            {(value) => (
                                                                <td>
                                                                    <Button
                                                                        disabled={
                                                                            !!value.formIsOpen
                                                                        }
                                                                        type="button"
                                                                        color="outline-primary"
                                                                        onClick={() => this.props.onEditEmployeeLongTermStatus(
                                                                            selectedEmployeeLongTermStatus,
                                                                        )}
                                                                        size="sm"
                                                                    >
                                                                        Edit
                                                                    </Button>
                                                                </td>
                                                            )}
                                                        </CommonContext.Consumer>
                                                    </Can>
                                                </tr>
                                            );
                                        },
                                    )
                                )}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </>
        );
    }
}

EmployeeLongTermStatusInfo.contextType = CommonContext;
